<section [class.border]="boxed()" [class.border-neutral-20]="boxed()" [class.px-4]="boxed()" [class.py-3]="boxed()" [class.mt-3]="boxed()">
  <header class="flex items-center justify-between gap-3">
    <h3 class="m-0 text-base">
      {{ 'outlookSync.history.title' | translate }}
    </h3>
  </header>
  <kendo-grid
    [data]="history()"
    [loading]="loading()"
    class="history-grid mt-2"
    [resizable]="true"
  >
    <kendo-grid-column
      field="syncStatus"
      [title]="'outlookSync.history.columns.condition' | translate"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <span
          class="inline-flex items-center gap-2"
          [ngClass]="{
            'text-bush-green-120': dataItem.syncStatus === 'Complete',
            'text-info': dataItem.syncStatus === 'Syncing',
            'text-warning-140': dataItem.syncStatus === 'Warning',
            'text-error':
              dataItem.syncStatus !== 'Complete' &&
              dataItem.syncStatus !== 'Syncing' &&
              dataItem.syncStatus !== 'Warning',
          }"
        >
          <span
            class="inline-flex h-[18px] w-[18px] items-center justify-center rounded-full border border-transparent"
            [ngClass]="{
              'border-bush-green-120/25 bg-bush-green-120/12':
                dataItem.syncStatus === 'Complete',
              'border-info/25 bg-info/12': dataItem.syncStatus === 'Syncing',
              'border-warning/35 bg-warning/20':
                dataItem.syncStatus === 'Warning',
              'border-error-60/25 bg-error-60/15':
                dataItem.syncStatus !== 'Complete' &&
                dataItem.syncStatus !== 'Syncing' &&
                dataItem.syncStatus !== 'Warning',
            }"
            aria-hidden="true"
          >
            @switch (dataItem.syncStatus) {
              @case ('Complete') {
                <span
                  class="fa-icons icon-14 icon-solid icon-circle-check"
                ></span>
              }
              @case ('Syncing') {
                <span class="fa-icons icon-14 icon-arrows-rotate animate-spin"></span>
              }
              @case ('Warning') {
                <span class="fa-icons icon-14 icon-triangle-exclamation"></span>
              }
              @default {
                <span class="fa-icons icon-14 icon-xmark"></span>
              }
            }
          </span>
          <span>{{ dataItem.syncStatus }}</span>
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="amountOfRecordsInSync"
      [title]="inSyncColumnTitleKey() | translate"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.amountOfRecordsInSync ?? '-' }}
      </ng-template>
    </kendo-grid-column>

    @if (showIgnored()) {
      <kendo-grid-column
        field="amountOfRecordsIgnored"
        [title]="'outlookSync.history.columns.ignored' | translate"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.amountOfRecordsIgnored ?? 0 }}
        </ng-template>
      </kendo-grid-column>
    }

    <kendo-grid-column
      field="startedAt"
      [title]="'outlookSync.history.columns.started' | translate"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.startedAt | date: 'short' }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      field="completedAt"
      [title]="'outlookSync.history.columns.finished' | translate"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        @if (dataItem.syncStatus !== 'Syncing') {
          {{ dataItem.completedAt | date: 'short' }}
        }
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      field="elapsedTimeInMins"
      [title]="'outlookSync.history.columns.duration' | translate"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        @if (dataItem.syncStatus !== 'Syncing') {
          {{ dataItem.elapsedTimeInMins === 0 ? 1 : dataItem.elapsedTimeInMins }}
          {{
            'outlookSync.history.columns.durationUnit' | translate
          }}
        }
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      field="message"
      [title]="'outlookSync.history.columns.note' | translate"
    ></kendo-grid-column>

    <ng-template kendoGridNoRecordsTemplate>
      <div class="p-4 text-center text-component-text/55">
        {{ 'outlookSync.history.empty' | translate }}
      </div>
    </ng-template>

    <ng-template kendoGridToolbarTemplate position="bottom">
      <div class="flex w-full items-center justify-end">
        <button
          kendoButton
          fillMode="flat"
          type="button"
          class="!min-w-0 !px-1 text-neutral-70"
          [disabled]="loading()"
          (click)="refresh.emit()"
          aria-label="{{ 'outlookSync.history.refresh' | translate }}"
        >
          <span class="fa-icons icon-14 icon-rotate-right"></span>
        </button>
      </div>
    </ng-template>
  </kendo-grid>
</section>
